import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { GridColumn } from "@app/data/shared/models/grid-column";
import { BaseFilter } from "@app/data/shared/models/base-filter";
import "rxjs/add/operator/finally";
import * as wjCore from "wijmo/wijmo";
import * as wjXlsx from "wijmo/wijmo.grid.xlsx";
import * as wjPDF from "wijmo/wijmo.pdf";
import * as wjGridPDF from "wijmo/wijmo.grid.pdf";
import { COMPONENTS } from "@app/modules/shared/constants/components";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import {
  ExplorerService,
  ModalConfig,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { Subscription } from "rxjs/Subscription";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import { GridContainerComponent } from "@app/modules/shared/components/grid-container/grid-container.component";
import { UtilService } from "@app/modules/shared/services/util.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";

export interface InitState {
  label: string;
  payload: any;
  child?: Array<Object>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kl-grid",
  templateUrl: "./grid.component.html",
  styleUrls: ["./grid.component.scss"],
})
export class GridComponent
    implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @ViewChild(forwardRef(() => GridContainerComponent), {
    static: true,
  })
  gridContainerComponent: any;
  @ViewChild("customFilterComponent", { read: ViewContainerRef, static: true })
  customFilterComponent: ViewContainerRef;
  @Input() columns: Array<GridColumn>;
  @Input() authGroupList: Array<any>;
  @Input() filterObject: any;
  @Input() filterSelectItems: any;
  @Input() definition: string;
  @Input() templateContext: any;
  @Input() closeInside: boolean;
  @Input() deferResizing: boolean;
  @Input() filterByCompany: boolean;
  @Input() sortable: boolean;
  @Input() filterable: boolean;
  @Input() mode: any;
  @Input() tabId: string;
  @Input() customFilterOutlet: string;
  @Input() customFilter = false;
  @Input() approveRefresh = false;
  @Input() authGroupShow = false;
  @Input() modalClass: string;
  @Input() parentModuleName: string;
  @Input() moduleName: string;
  @Input() moduleType: string;
  @Input() gridName: string;
  @Input() fastFilterName: string;
  @Input() textToFilter: string;
  // TODO: refaktor edilecek, componentleri arrayden cekme stratejisini degistirmeliyiz Circular Dependency hatasina neden oluyor.
  // TODO: service { name, service }, outlet { buttonVisible, editButtonVisible, specialType }
  @Input() service: {
    service: string;
    filterChild?: string;
    form: string;
    name: string;
    showButton?: boolean;
    showDropDownButton?: boolean;
    specialType?: string;
    editByCustomField?: boolean;
    customFieldName?: string;
    customEndpoint?: string;
  };
  @Input() deleteOptions = {
    objectProperty: null,
    objectValue: null,
    alertMessage: null,
    alertProperty: null,
    delete_related: null,
    deleteWithConfirm: false,
    inputPlaceholder: null,
  };
  @Input() editOptions = {
    objectProperty: null,
    objectValue: null,
    alertMessage: null,
  };
  @Input() alertType = "error";
  @Input() alertMessage = "";
  @Input() alertShow = false;
  @Input() dblSelect = false;
  @Input() showToolbar = true;
  @Input() actions: Array<{ method: Function; icon?: string; slug: string }>;
  @Input() doAdd = true;
  @Input() processesActions: Array<{
    method: Function;
    icon: string;
    slug: string;
  }>;
  @Input() customToolbar: Array<{
    method: Function;
    icon: string;
    slug: string;
  }>;

  @Output() onCloseAlert = new EventEmitter();
  @Output() onDblClickCall = new EventEmitter();

  fastFilterObject: any;
  pageSize: number;
  tunnel: Subscription;
  approveTunnel: Subscription;
  initStatesWithoutChild: Array<InitState>;
  initStatesWithChild: Array<InitState>;
  // collectionData: Array<any>;
  collectionView: wjCore.CollectionView;
  pageOffset: number;
  totalCount: number;
  loading = false;
  _filter: BaseFilter<any>;
  disabledButton: boolean;
  detailFilter: any;
  filteredObject: any;
  currentItem: any;
  endProssessTunnel: Subscription;

  constructor(
      private apiService: ApiService,
      private explorer: ExplorerService,
      public changeDetector: ChangeDetectorRef,
      private utilService: UtilService,
      private alertService: KlSweetAlertService,
      private dateConvert: ConvertIsoDateService,
      private klLoadingService: KlLoadingService,
      private toastService: ToastService
  ) {}

  ngOnInit() {
    this.fastFilterName = this.moduleName + "_FAST_FILTER";
    // let commitObject = Object.create(null);
    // commitObject = {
    //   parent: {
    //     module: this.parentModuleName
    //   },
    //   module: this.moduleName,
    //   key: this.fastFilterName,
    //   type: 'FILTER'
    // };
    // let fakeFilterInstance = Object.create(null);
    this.filter({
      filter: this.filterObject ? this.filterObject : {},
      query: {
        paging: {
          limit: 10,
          fetch: "EAGER",
        },
      },
    });
    this.klLoadingService.show("loading");
    // this.apiService.getFilteredData('design', commitObject).subscribe(response => {
    //   if (response.data.length > 0) {
    //     fakeFilterInstance = JSON.parse(response.data[0].content);
    //     this.fastFilterObject = this.utilService.deepCopy(response.data[0]);
    //     if (this.filterObject) {
    //       Object.assign(fakeFilterInstance.filter, this.filterObject);
    //     }
    //   } else {
    //     fakeFilterInstance = {
    //       filter: this.filterObject ? this.filterObject : {},
    //       query: {
    //         paging: {
    //           limit: 10,
    //           fetch: 'EAGER'
    //         }
    //       }
    //     };
    //   }
    //   if (!this.filterByCompany) {
    //     this.filter(fakeFilterInstance);
    //   }
    // }, error => this.handleError(error));
  }

  getCurrentItem() {
    return this.gridContainerComponent.currentItem;
  }

  onFilter(event) {
    this.filteredObject = UtilService.deepCopy(event.filter);
    Object.assign(
        event.filter,
        this.detailFilter ? this.detailFilter.filter : {}
    );
    this.filter(event);
  }

  editRecord(payload) {
    this.alertShow = false;
    this.klLoadingService.show("loading");

    const hasIds = payload?.ids !== undefined && payload?.ids !== null;

    const serviceUrl = hasIds
        ? `${this.service.service}/product-key`
        : this.service.service;


    const requestId = hasIds
        ? payload.logo_product_key
        : payload.id;

    if (!hasIds && payload?.id && payload?.id !== Number(payload.id)) {
      payload.id = Number(payload.id);
    }

    this.apiService.getDataById(serviceUrl, requestId).subscribe(
        (resData) => {
          if (resData === undefined) {
            this.handleError("error_data");
            return;
          }

          if (hasIds) {
            const hasCustomer =
                payload?.customer_id != null ||
                payload?.customer_description != null ||
                payload?.customer_code != null;

            const _customer = hasCustomer
                ? {
                  customer_id: payload?.customer_id ?? null,
                  customer_description: payload?.customer_description ?? null,
                  customer_code: payload?.customer_code ?? null,
                }
                : null;

            const branch_count = payload?.sube_sayisi;

            const mergedData = {
              ...resData,
              ...(branch_count != null ? { branch_count } : {}),
              ...(_customer ? { _customer } : {}),
            };
            this.klLoadingService.hide();
            this.openFormAsEdit(mergedData);
            return;
          }

          if (this.editOptions.objectProperty) {
            const data = resData[this.editOptions.objectProperty];
            const valueType = typeof this.editOptions.objectValue;
            let acceptEdit = true;

            if (valueType === "string") {
              if (data === this.editOptions.objectValue) {
                acceptEdit = false;
              }
            } else {
              this.editOptions.objectValue.forEach((value) => {
                if (value === data) {
                  acceptEdit = false;
                }
              });
            }

            if (acceptEdit) {
              this.apiService
                  .lockData(this.service.service, payload.id)
                  .finally(() => {
                    this.klLoadingService.hide();
                    this.changeDetector.markForCheck();
                  })
                  .subscribe(
                      () => this.openFormAsEdit(resData),
                      (errEdit) => this.handleError(errEdit)
                  );
            } else {
              this.handleError(this.editOptions.alertMessage);
            }
          } else {
            this.apiService
                .lockData(this.service.service, payload.id)
                .finally(() => {
                  this.klLoadingService.hide();
                  this.changeDetector.markForCheck();
                })
                .subscribe(
                    () => this.openFormAsEdit(resData),
                    (errEdit) => this.handleError(errEdit)
                );
          }
        },
        (errData) => this.handleError(errData)
    );
  }

  dblClickCall(payload) {
    if (this.mode === "DIALOG") {
      if (this.dblSelect) {
        this.onDblClickCall.emit(payload);
      } else {
        this.editRecord(payload);
      }
    } else {
      this.editRecord(payload);
    }
  }

  viewRecord(payload) {
    this.alertShow = false;
    this.klLoadingService.show("loading");

    const useCustomView =
        this.service?.editByCustomField &&
        this.service?.customFieldName &&
        this.service?.customEndpoint;

    const fieldName = this.service?.customFieldName;

    // normalize: taxnr -> tax_nr
    const normalizedFieldName =
        fieldName === "taxnr" ? "tax_nr" : fieldName;

    const requestId = useCustomView
        ? payload?.[normalizedFieldName]
        : payload?.id;

    const serviceUrl = useCustomView
        ? `${this.service.service}/${this.service.customEndpoint}`
        : this.service.service;

    // güvenlik kontrolü (undefined requesti engeller)
    if (!requestId) {
      this.klLoadingService.hide();
      this.handleError(`ID bulunamadı: ${normalizedFieldName || "id"}`);
      return;
    }

    this.apiService.getDataById(serviceUrl, requestId).subscribe(
        (response) => {
          this.klLoadingService.hide();

          if (!response) {
            this.handleError("error_data");
            return;
          }

          this.openFormAsView(response);
        },
        (error) => {
          this.klLoadingService.hide();
          this.handleError(error);
        }
    );
  }
  addRecord(initState?: InitState) {
    this.openFormAsNew(initState ? initState.payload : {});
  }

  infoRecord(payload) {
    this.alertShow = false;
    this.klLoadingService.show("loading");
    this.apiService.getChanges(this.service.service, payload.id).subscribe(
        (resData) => {
          if (resData === undefined) {
            this.handleError("error_data");
          } else {
            this.klLoadingService.hide();
            this.alertService.entryInfo({}, resData);
          }
        },
        (errData) => {
          this.handleError(errData);
        }
    );
  }

  deleteRecord(payload) {
    this.klLoadingService.show("loading");
    this.apiService.getDataById(this.service.service, payload.id).subscribe(
        (responseGetByID) => {
          if (responseGetByID === undefined) {
            this.handleError("error_data");
          } else {
            this.klLoadingService.hide();
            if (
                this.deleteOptions.objectProperty === null ||
                this.deleteOptions.objectProperty === undefined
            ) {
              this.alertService.alertDelete(
                  {
                    title: "Uyarı",
                    text: "Kayıt Silinecektir",
                    customClass: "kl-alert",
                    showCloseButton: false,
                    confirm: this.deleteOptions.deleteWithConfirm,
                    inputPlaceholder: this.deleteOptions.inputPlaceholder,
                  },
                  (response) => {
                    this.klLoadingService.show("deleting");
                    this.alertShow = false;
                    this.apiService
                        .deleteData(
                            response === 1 && this.deleteOptions.deleteWithConfirm
                                ? this.deleteOptions.delete_related
                                : this.service.service,
                            payload.id
                        )
                        .finally(() => {
                          this.klLoadingService.hide();
                          this.changeDetector.markForCheck();
                        })
                        .subscribe(
                            () => {
                              this.toastService.toastSuccess();
                              this.filter(this._filter);
                            },
                            (err) => this.handleError(err)
                        );
                  }
              );
            } else {
              const data = responseGetByID[this.deleteOptions.objectProperty];
              const valueType = typeof this.deleteOptions.objectValue;
              let acceptDelete = true;
              if (valueType === "string") {
                acceptDelete = data !== this.deleteOptions.objectValue;
              } else {
                this.deleteOptions.objectValue.forEach((value) => {
                  if (value === data) {
                    acceptDelete = false;
                  }
                });
              }
              if (acceptDelete) {
                this.alertService.alertDelete(
                    {
                      title: "Uyarı",
                      text: "Kayıt Silinecektir",
                      customClass: "kl-alert",
                      showCloseButton: false,
                      confirm: this.deleteOptions.deleteWithConfirm,
                      inputPlaceholder: this.deleteOptions.inputPlaceholder,
                    },
                    (response) => {
                      this.klLoadingService.show("deleting");
                      this.alertShow = false;
                      this.apiService
                          .deleteData(
                              response === 1 && this.deleteOptions.deleteWithConfirm
                                  ? this.deleteOptions.delete_related
                                  : this.service.service,
                              payload.id
                          )
                          .finally(() => {
                            this.klLoadingService.hide();
                            this.changeDetector.markForCheck();
                          })
                          .subscribe(
                              () => {
                                this.toastService.toastSuccess();
                                this.filter(this._filter);
                              },
                              (err) => this.handleError(err)
                          );
                    }
                );
              } else {
                this.handleError(
                    this.deleteOptions.alertProperty
                        ? responseGetByID[this.deleteOptions.alertProperty] +
                        this.deleteOptions.alertMessage
                        : this.deleteOptions.alertMessage
                );
              }
            }
          }
        },
        (error) => this.handleError(error)
    );
  }

  onExport(event) {
    if (event === "XLSX") {
      wjXlsx.FlexGridXlsxConverter.save(
          this.gridContainerComponent.flexGrid,
          {
            includeColumnHeaders: false,
            includeCellStyles: false,
          },
          this.dateConvert.convertDate(new Date()) +
          "-" +
          this.service.name +
          ".xlsx"
      );
    }
    if (event === "PDF") {
      const doc = new wjPDF.PdfDocument({
        ended: (sender, args) => {
          wjPDF.saveBlob(
              args.blob,
              this.dateConvert.convertDate(new Date()) +
              "-" +
              this.service.name +
              ".pdf"
          );
        },
      });
      doc.drawText("", 0, 30);
      wjGridPDF.FlexGridPdfConverter.drawToPosition(
          this.gridContainerComponent.flexGrid,
          doc,
          new wjCore.Point(0, 40),
          null,
          null,
          {
            maxPages: 10,
            styles: {
              cellStyle: {
                backgroundColor: "#ffffff",
                borderColor: "#c6c6c6",
              },
              headerCellStyle: {
                backgroundColor: "#eaeaea",
              },
            },
          }
      );
      doc.end();
    }
  }

  closeAlert() {
    this.alertMessage = "";
    this.alertShow = false;
    this.onCloseAlert.emit();
  }

  onImport(event) {}

  movePage(offset: number) {
    this.pageOffset = offset;
    this._filter.query.paging.offset = this.pageOffset;
    this.filter(this._filter);
  }

  filter(filter: any) {
    this.alertShow = false;
    this.klLoadingService.show("loading");
    if (this.templateContext) {
      if (this.templateContext.hasOwnProperty("filter")) {
        Object.keys(filter.filter).forEach((key) => {
          if (this.templateContext.filter.hasOwnProperty(key)) {
            delete this.templateContext.filter[key];
          }
        });
        Object.assign(filter.filter, this.templateContext.filter);
        filter.parameters = this.templateContext.hasOwnProperty("parameters")
            ? this.templateContext.parameters
            : [];
      }
    }
    const emptyObject = Object.create(null);
    const emptyArray = [];
    this.apiService
        .getFilteredData(
            this.service.service,
            filter,
            this.service.filterChild ? this.service.filterChild : null
        )
        .finally(() => {
          this.klLoadingService.hide();
        })
        .subscribe(
            (response) => {
              if (response === undefined) {
                this.handleError("error_data");
              } else {
                const query = response.query;
                if (query.paging) {
                  this.pageOffset = query.paging.offset;
                  this.totalCount = query.paging.total;
                  this.pageSize = query.paging.limit;
                }
                this._filter = filter;
                const collectionData = response.data;

                if (Array.isArray(collectionData)) {
                  collectionData.forEach((item) => {
                    if (
                        item &&
                        item.id === undefined &&
                        item.ids !== undefined
                    ) {
                      item.id = item.ids;
                      if (item.ids !== undefined) {}
                    }
                  });
                }
                if (Object.keys(collectionData).length > 0) {
                  this.collectionView = new wjCore.CollectionView(collectionData);
                  this.disabledButton = false;
                  // this.collectionView.refresh();
                  this.changeDetector.markForCheck();
                } else {
                  this.disabledButton = true;
                  for (let i = 0; i < this.columns.length; i++) {
                    emptyObject[this.columns[i].binding] = null;
                  }
                  emptyArray.push(emptyObject);
                  this.collectionView = new wjCore.CollectionView(emptyArray);
                  // this.collectionView.refresh();
                }
                this.changeDetector.markForCheck();
              }
            },
            (error) => this.handleError(error)
        );
  }

  // TODO: Refaktor edilecek, ioc kullanilacak.
  openFormAsView(params: any) {
    switch (this.mode) {
      case "TAB":
        const tabConfig = <TabConfig>{
          id: this.service.name + "01_view" + params.id,
          title: this.service.name,
          isCloseable: true,
          childTemplate: <DynamicComponent>{
            mode: "view",
            template: forwardRef(() => COMPONENTS[this.service.form]),
            service: this.service.service,
            tabId: this.service.name + "01_view" + params.id,
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            isReadOnly: true,
          },
        };
        this.explorer.openTab(tabConfig);
        break;
      case "DIALOG":
        const modalConfig = <ModalConfig>{
          title: this.service.name,
          childTemplate: <DynamicComponent>{
            template: COMPONENTS[this.service.form],
            dataContext: UtilService.deepCopy(params),
            modalId: this.service.name + "01_view_modal",
            moduleType: this.moduleType ? this.moduleType : "",
            mode: "view",
            isReadOnly: true,
            modalClass: this.modalClass ? this.modalClass : "",
          },
        };
        this.explorer.openModal(modalConfig);
        break;
      default:
        const tabConfigDefault = <TabConfig>{
          id: this.service.name + "01_view" + params.id,
          title: this.service.name,
          isCloseable: true,
          childTemplate: <DynamicComponent>{
            mode: "view",
            tabId: this.service.name + "01_view" + params.id,
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            template: COMPONENTS[this.service.form],
            service: this.service.service,
            isReadOnly: true,
          },
        };
        this.explorer.openTab(tabConfigDefault);
        break;
    }
  }

  openFormAsNew(params: any) {
    switch (this.mode) {
      case "TAB":
        const tabConfig = <TabConfig>{
          id: this.service.name + "01_new" + (params ? params.type : ""),
          title: this.service.name,
          isCloseable: true,
          childTemplate: <DynamicComponent>{
            mode: "add",
            tabId: this.service.name + "01_new" + (params ? params.type : ""),
            listTabId: this.tabId,
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            template: COMPONENTS[this.service.form],
            service: this.service.service,
            isReadOnly: false,
          },
        };
        this.explorer.openTab(tabConfig);
        break;
      case "DIALOG":
        const modalConfig = <ModalConfig>{
          title: this.service.name,
          childTemplate: <DynamicComponent>{
            template: COMPONENTS[this.service.form],
            modalId:
                this.service.name + "01_new_modal" + (params ? params.type : ""),
            listTabId: this.tabId,
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            mode: "add",
            closeInside: this.closeInside,
            modalClass: this.modalClass,
            isReadOnly: false,
          },
        };
        this.explorer.openModal(modalConfig);
        break;
      default:
        const tabConfigDefault = <TabConfig>{
          id: this.service.name + "01_new" + (params ? params.type : ""),
          title: this.service.name,
          isCloseable: true,
          childTemplate: <DynamicComponent>{
            mode: "add",
            tabId: this.service.name + "01_new" + (params ? params.type : ""),
            listTabId: this.tabId,
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            template: COMPONENTS[this.service.form],
            service: this.service.service,
            isReadOnly: false,
          },
        };
        this.explorer.openTab(tabConfigDefault);
        break;
    }
  }

  openSortable() {
    switch (this.mode) {
      case "TAB":
        const tabConfig = <TabConfig>{
          id: this.service.name + "01_sortable",
          title: this.service.name,
          isCloseable: true,
          childTemplate: <DynamicComponent>{
            mode: "sortable",
            dataContext: {},
            moduleType: this.moduleType ? this.moduleType : "",
            template: COMPONENTS[this.service.form],
            service: this.service.service,
            isReadOnly: true,
          },
        };
        this.explorer.openTab(tabConfig);
        break;
      case "DIALOG":
        const modalConfig = <ModalConfig>{
          title: this.service.name,
          childTemplate: <DynamicComponent>{
            template: COMPONENTS[this.service.form],
            dataContext: {},
            moduleType: this.moduleType ? this.moduleType : "",
            mode: "sortable",
            closeInside: this.closeInside,
            modalClass: this.modalClass,
            isReadOnly: true,
          },
        };
        this.explorer.openModal(modalConfig);
        break;
      default:
        const tabConfigDefault = <TabConfig>{
          id: this.service.name + "01_sortable",
          title: this.service.name,
          isCloseable: true,
          childTemplate: <DynamicComponent>{
            mode: "sortable",
            dataContext: {},
            moduleType: this.moduleType ? this.moduleType : "",
            template: COMPONENTS[this.service.form],
            service: this.service.service,
            isReadOnly: true,
          },
        };
        this.explorer.openTab(tabConfigDefault);
        break;
    }
  }

  openFormAsEdit(params: any) {
    switch (this.mode) {
      case "TAB":
        const tabConfig = <TabConfig>{
          id: this.service.name + "01_edit" + params.id,
          title: this.service.name,
          childTemplate: <DynamicComponent>{
            mode: "edit",
            tabId: this.service.name + "01_edit" + params.id,
            listTabId: this.tabId,
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            template: COMPONENTS[this.service.form],
            service: this.service.service,
            isReadOnly: false,
          },
          isCloseable: true,
        };
        this.explorer.openTab(tabConfig);
        break;
      case "DIALOG":
        const modalConfig = <ModalConfig>{
          title: this.service.name,
          mode: "edit",
          stateSelector: this.service.service,
          childTemplate: <DynamicComponent>{
            template: COMPONENTS[this.service.form],
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            mode: "edit",
            modalId: this.service.name + "01_edit_modal",
            listTabId: this.tabId,
            closeInside: this.closeInside,
            isReadOnly: false,
            modalClass: this.modalClass ? this.modalClass : "",
          },
        };
        this.explorer.openModal(modalConfig);
        break;
      default:
        const tabConfigDefault = <TabConfig>{
          id: this.service.name + "01_edit" + params.id,
          title: this.service.name,
          isCloseable: true,
          childTemplate: <DynamicComponent>{
            mode: "edit",
            tabId: this.service.name + "01_edit" + params.id,
            listTabId: this.tabId,
            dataContext: UtilService.deepCopy(params),
            moduleType: this.moduleType ? this.moduleType : "",
            template: COMPONENTS[this.service.form],
            service: this.service.service,
            isReadOnly: false,
          },
        };
        this.explorer.openTab(tabConfigDefault);
        break;
    }
  }

  onCustomFilter(event) {
    this.pageSize = event.pageSize;
    const modalConfig = <ModalConfig>{
      title: "detail_filter",
      stateSelector: null,
      childTemplate: <DynamicComponent>{
        template: COMPONENTS[this.customFilterOutlet],
        dataContext: {
          pageSize: this.pageSize,
          state: this.customFilterOutlet,
          filter: this.detailFilter,
          module: this.moduleName,
          parentModule: this.parentModuleName,
        },
        modalId: this.customFilterOutlet + "01_detail_filter_modal",
        isReadOnly: false,
        modalClass: "bottom-fixed",
      },
    };
    this.explorer.openModal(modalConfig);
  }

  ngAfterViewInit() {
    if (this.customFilter) {
      this.tunnel = this.explorer.transferState$.subscribe((state) => {
        if (state.state === this.customFilterOutlet) {
          this.detailFilter = state.payload;
          if (!state.payload.close) {
            if (this.filterObject) {
              Object.assign(
                  state.payload.filter,
                  this.filterObject,
                  this.filteredObject ? this.filteredObject : {}
              );
            }
            this.filter(state.payload);
          }
        }
      });
    }
    if (this.approveRefresh) {
      this.approveTunnel = this.explorer.doRefresh$.subscribe((refresh) => {
        if (refresh) {
          this.filter(this._filter);
        }
      });
    }
    this.endProssessTunnel = this.explorer.endProssessRefresh$.subscribe(
        (response) => {
          if (response) {
            if (response === this.tabId) {
              this.filter(this._filter);
            }
          }
        }
    );
  }

  handleError(error) {
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    this.changeDetector.markForCheck();
  }

  ngOnChanges() {
    this.changeDetector.markForCheck();
  }

  ngOnDestroy() {
    if (this.customFilter) {
      this.tunnel.unsubscribe();
    }
    if (this.approveRefresh) {
      this.approveTunnel.unsubscribe();
    }
    if (this.endProssessTunnel) {
      this.endProssessTunnel.unsubscribe();
    }
  }
}
